<template>
  <div>
    <div class="padding">
      <Form :labelWidth="60" ref="grantForm" :rules="grantValidationRules" :model="grantForm">
        <FormItem label="组织" prop="orgIds">
          <TreePicker :option="orgOption" multiple choose-mode="independent"
                      ref="orgTreePicker" v-model="grantForm.orgIds"></TreePicker>
        </FormItem>
      </Form>
    </div>
    <footer class="h-modal-footer">
      <Button @click="$emit('close')" :loading="loading">取消</Button>
      <Button color="primary" :loading="loading" @click="grantSave()">确认</Button>
    </footer>
  </div>
</template>

<script>
import {mapState} from "vuex";

/**
 * 该组件用于给组织授权模板。
 * 包含表单输入、组织树选择器以及授权保存功能。
 */
export default {
  name: "GrantOrg",
  props: {
    template: Object,
  },
  computed: {
    ...mapState(['orgDatas']),
  },
  data() {
    return {
      loading: false,
      grantForm: {
        orgIds: [],
        template: null,
      },
      orgOption: {
        keyName: 'id',
        parentName: 'parentId',
        titleName: 'title',
        dataMode: 'list',
        datas: []
      },
      grantValidationRules: {
        required: ['orgIds'],
      },
    }
  },
  methods:{
    grantSave() {
      let validResult = this.$refs.grantForm.valid();
      if (validResult.result) {
        this.loading = true;
        this.$api.report.template.grant(this.grantForm).then(({data}) => {
          this.$emit('success');
        }).finally(() => {
          this.loading = false;
        });
      }
    },
  },
  created() {
    this.grantForm.template = this.template;
    this.grantForm.orgIds = [];
    this.orgOption.datas = this.orgDatas.map(val => {
      return {
        id: val.id,
        name: val.name,
        type: val.type,
        title: `[${val.code}]${val.name}`,
        parentId: val.parentId,
      }
    });
    this.$nextTick(() => {
      this.$refs.orgTreePicker.expandAll();
    });
  }
}
</script>

<style scoped>

</style>